/*
 * Requires:
 * - HTMLElement with ref="wrapper"
 * - loadData() method
 * - loading property
 */

export default {
  data() {
    return {
      stickyStyles: {},
      stickyFiltersButton: true,
      stickyFiltersVisible: false,
      lastScrollPosition: 0,
    };
  },
  methods: {
    onScroll() {
      if (this.loading) {
        return;
      }
      const node = this.$refs.wrapper.$el || this.$refs.wrapper;
      const bottomEdge =
        node.getBoundingClientRect().bottom - window.innerHeight;
      const offset = window.innerHeight * 0.3;
      if (bottomEdge - offset < 0) {
        this.loadData(true);
      }
    },
    toggleSitckyFilters() {
      if (!this.stickyFiltersVisible) {
        this.stickyStyles = {
          position: 'sticky',
          top: '1rem',
          zIndex: 10,
          maxHeight: 'calc(100vh - 6rem)',
          overflowY: 'auto',
          transform: 'translateY(-100%) translateY(-1rem)',
        };
        setTimeout(() => {
          this.$delete(this.stickyStyles, 'transform');
          this.$set(this.stickyStyles, 'transition', 'transform 1s');
        }, 100);
      } else {
        this.stickyStyles.transform = 'translateY(-100%) translateY(-1rem)';
        setTimeout(() => {
          this.stickyStyles = {};
        }, 1100);
      }
      this.stickyFiltersVisible = !this.stickyFiltersVisible;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.onScroll);
  },
};
